module.exports = __webpack_public_path__ + "static/media/reg.11026f63.jpg";